import { Icon, type IconKind } from '@elva/ui';

export interface GrowthModuleCardProps {
  label: string;
  subtitle: string;
  icon: IconKind;
  collapsed?: boolean;
}

export function GrowthModuleCard({
  label,
  subtitle,
  icon,
  collapsed = false,
}: GrowthModuleCardProps) {
  if (collapsed) {
    return (
      <div
        title={label}
        className="mx-auto flex h-9 w-9 items-center justify-center rounded-[9px] border border-[var(--cream-2)] bg-[var(--cream-1)] text-[var(--growth-accent,var(--info))] shadow-[var(--sh-1)]"
      >
        <Icon kind={icon} size={17} stroke={1.9} />
      </div>
    );
  }

  return (
    <div>
      <div className="px-1.5 pb-2.5 font-[var(--font-mono)] text-[11px] font-bold uppercase tracking-[0.14em] text-[var(--ink-3)]">
        Module
      </div>
      <div className="flex w-full items-center gap-[11px] rounded-[15px] border border-[var(--cream-2)] bg-[var(--cream-1)] px-3.5 py-[13px] text-left shadow-[0_1px_2px_rgba(20,20,20,0.04),0_10px_26px_-16px_rgba(20,20,20,0.3)]">
        <span className="inline-flex h-[30px] w-[30px] shrink-0 items-center justify-center rounded-[9px] bg-[var(--growth-pill,var(--info-tint))] text-[var(--growth-accent,var(--info))]">
          <Icon kind={icon} size={17} stroke={1.9} />
        </span>
        <span className="min-w-0 flex-1">
          <span className="block truncate text-[14.5px] font-bold tracking-[-0.01em] text-[var(--ink-0)]">
            {label}
          </span>
          <span className="mt-px block truncate text-[12.5px] text-[var(--ink-2)]">
            {subtitle}
          </span>
        </span>
      </div>
    </div>
  );
}
